<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    class="elevation-1"
    fixed-header
  >
    <template v-slot:item="{ item }">
      <tr>
        <td class="row-item" @click="get(item.props.title.id)">
          <router-link
            :to="{
              name: 'content-page-edit',
              params: { id: item.props.title.id },
            }"
            >{{ item.columns.name }}</router-link
          >
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const ContentPageRepository = RepositoryFactory.get("contentPage");

export default {
  data() {
    return {
      items: [],
      headers: [
        {
          title: "Наименование",
          align: "start",
          sortable: false,
          key: "name",
        },
      ],
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      this.loading = true;
      const result = await ContentPageRepository.list();
      if (result) {
        if (result.data.status === "success") {
          this.items = result.data.data;
        }
      }
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.row-item:hover {
  background-color: #1697f6;
  color: #fff;
}
</style>
